/**
 * @returns {never}
 */
export const throwError = (...parameters) => {
  throw new Error(...parameters);
};
